import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TeclaContaje/updateTeclaContaje`, method: 'POST', body: values, token: token})
}
